import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAcombaBridgeStore } from '../../stores/acombaBridgeStore';
import { useSessionStore } from '../../stores/session/sessionStore';
import { TranslationKey } from '../../i18n/translationKeys';
import { Label } from '../../ui/Label/Label';

export const ConnectedView: React.FC = () => {
    const { t } = useTranslation();
    const bridgeInfo = useAcombaBridgeStore((s) => s.bridgeInfo);
    const sessionInfo = useAcombaBridgeStore((s) => s.sessionInfo);
    const companyName = useAcombaBridgeStore((s) => s.companyName);
    const companyMatchStatus = useAcombaBridgeStore((s) => s.companyMatchStatus);
    const sessionKind = useSessionStore((s) => s.sessionKind);

    const isMismatch = sessionKind === 'desktop' && companyMatchStatus === 'mismatch';
    const isUnverifiable = sessionKind === 'desktop' && companyMatchStatus === 'unverifiable';

    return (
        <div className="flex flex-col gap-xl">
            {/* Fields: health + company + user */}
            <div className="flex flex-col gap-l">
                <div className="flex flex-col gap-s">
                    <Label>{t(TranslationKey.AcombaBridge.Connected.BridgeStatusLabel)}</Label>
                    <span className="inline-flex items-center gap-s">
                        <span className="w-2 h-2 rounded-full bg-success" />
                        <span className="text-s text-primary-1100">
                            {t(TranslationKey.AcombaBridge.Connected.StatusHealthy)}
                            {bridgeInfo?.bridgeVersion ? ` · v${bridgeInfo.bridgeVersion}` : ''}
                        </span>
                    </span>
                </div>
                <div className="flex flex-col gap-s">
                    <Label>{t(TranslationKey.AcombaBridge.Connected.SdkStatusLabel)}</Label>
                    <span className="inline-flex items-center gap-s">
                        <span className="w-2 h-2 rounded-full bg-success" />
                        <span className="text-s text-primary-1100">
                            {t(TranslationKey.AcombaBridge.Connected.StatusHealthy)}
                            {bridgeInfo?.sdkVersion ? ` · v${bridgeInfo.sdkVersion}` : ''}
                        </span>
                    </span>
                </div>
                <div className="flex flex-col gap-s">
                    <Label>{t(TranslationKey.AcombaBridge.Connected.CompanyLabel)}</Label>
                    <p data-testid="acomba-bridge-company-name" className="text-s text-primary-1100">
                        {companyName ?? sessionInfo?.companyPath ?? '—'}
                    </p>
                    {isMismatch && (
                        <p data-testid="acomba-bridge-company-mismatch-warning" className="text-s text-warning">
                            {t(TranslationKey.AcombaBridge.CompanyMatch.MismatchWarning)}
                        </p>
                    )}
                    {isUnverifiable && (
                        <p data-testid="acomba-bridge-company-unverifiable-note" className="text-s text-primary-500">
                            {t(TranslationKey.AcombaBridge.CompanyMatch.UnverifiableNote)}
                        </p>
                    )}
                </div>
                <div className="flex flex-col gap-s">
                    <Label>{t(TranslationKey.AcombaBridge.Connected.UserLabel)}</Label>
                    <p className="text-s text-primary-1100">
                        {[sessionInfo?.userName, sessionInfo?.userCardPos != null ? `#${sessionInfo.userCardPos}` : null].filter(Boolean).join(' · ') || '—'}
                    </p>
                </div>
            </div>
        </div>
    );
};
